import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  selectedEventId: Yup.string().required('Please select an event'),
  products: Yup.array().of(
    Yup.object().shape({
      pid: Yup.string(),
      name: Yup.string().required('Product name is required'),
      description: Yup.string().nullable().notRequired(),
      price: Yup.number()
        .typeError('Product price is required')
        .required('Product price is required'),
      maxQuantity: Yup.number()
        .typeError('Available stock is required')
        .required('Available stock is required'),
      defaultQuantity: Yup.number()
        .typeError('Default quantity is required')
        .default(0)
        .required('Default quantity is required'),
      limitPerOrder: Yup.number()
        .typeError('Limit per order is required')
        .required('Limit per order is required'),
      minOrderQty: Yup.number()
        .typeError('Minimum order quantity must be greater than 0')
        .min(1, 'Minimum order quantity must be greater than 0')
        .required('Minimum order quantity must not be blank.'),
      photoUrls: Yup.array().notRequired().nullable(),
      splitCasePurchase: Yup.lazy((value) => {
        if (!value || !value.itemsPerCase || !value?.costPerItem) {
          return Yup.object().notRequired().nullable()
        }
        return Yup.object().shape({
          itemsPerCase: Yup.number()
            .typeError('Items per case must be a number')
            .min(1, 'Items per case must be at least 1')
            .nullable()
            .notRequired(),
          costPerItem: Yup.number()
            .typeError('Cost per item must be a number')
            .min(0.01, 'Cost per item must be greater than 0')
            .nullable()
            .notRequired(),
          minItemOrder: Yup.number()
            .typeError('Minimum item order must be a number')
            .min(1, 'Minimum item order must be at least 1')
            .nullable()
            .notRequired(),
          fulfillCondition: Yup.string().nullable().notRequired(),
          acknowledgementRequiredPayAfter: Yup.boolean().nullable().notRequired().default(false),
          photoUrl: Yup.string().nullable().notRequired(),
        })
      }),
      subItems: Yup.array().of(
        Yup.object().shape({
          type: Yup.string().required('Sub item name is required'),
          required: Yup.boolean().default(false),
          list: Yup.array().of(
            Yup.object().shape({
              name: Yup.string().required('Option name is required'),
              price: Yup.number()
                .typeError('Option price is required')
                .required('Option price is required'),
            })
          ),
        })
      ),
    })
  ),
})
